import { render, staticRenderFns } from "./SupportList.vue?vue&type=template&id=76a9d8e5&scoped=true&lang=pug"
import script from "./SupportList.vue?vue&type=script&lang=ts"
export * from "./SupportList.vue?vue&type=script&lang=ts"
import style0 from "./SupportList.vue?vue&type=style&index=0&id=76a9d8e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a9d8e5",
  null
  
)

export default component.exports